export const DEVICE_CONFIG = {
  SCREEN_WIDTH: 280,
  SCREEN_HEIGHT: 400,
  BASE_FONT_SIZE: 16, 
  SCALE_RATIO: 1, 
  NAME: "Zebra MC3300M",
};